// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * GameStateContext - Root Provider for All Game State
 * Combines all context providers in one place
 */

import React from 'react';
import { FuelProvider } from './FuelContext';
import { CreditsProvider } from './CreditsContext';
import { ShipHealthProvider } from './ShipHealthContext';
import { WeaponsProvider } from './WeaponsContext';
import { UpgradesProvider } from './UpgradesContext';

export function GameStateProvider({ children }) {
  return (
    <FuelProvider>
      <CreditsProvider>
        <ShipHealthProvider>
          <WeaponsProvider>
            <UpgradesProvider>
              {children}
            </UpgradesProvider>
          </WeaponsProvider>
        </ShipHealthProvider>
      </CreditsProvider>
    </FuelProvider>
  );
}

export default GameStateProvider;
